<template>
    <div class="search-box">
        <el-input
                v-model="keyword"
                class="w-50 m-2"
                size="large"
                placeholder="搜索..."
                :prefix-icon="Search"
                clearable
                v-loading="loadingFlag"
                @change="changeKeyword"
                style="width: calc(100% - 6em); display: inline-block"
        />
    </div>

    <div class="type-toggle-box">
        <ListDisplayToggle
            :type="viewType"
            @clickBtn="changeViewType"
        />
    </div>

    <div class="search-result">
        <el-row :gutter="10">
            <el-col
                :span="cols"
                v-for="(value, index) in materialList"
                :key="value.id"
                class="record-box"
            >
                <SearchMaterialResult
                    :obj="value"
                    :titleDes="`${value.wa}-${value.siojournal}`"
                    :imgUrl="myUtil.generateProductImg(value)"
                    :name="value.productname"
                    :subName="viewType === 'block' ? `${value.wa}-${value.siojournal}` : ''"
                    :description="value.description"
                    :btn-label="i18n.tkey('lang_check')"
                    :tag="viewType"
                    @click-go-shop="goShop"
                />
            </el-col>
        </el-row>

        <el-empty
            :description="i18n.tkey('lang_temporary_no_data')"
            v-show="materialList.length == 0"
        />

    </div>
</template>

<script setup>
    import {getCurrentInstance, ref, onMounted, onBeforeMount, inject} from 'vue'
    import {Search} from '@element-plus/icons-vue';
    import MaterialPEResultComponent from "@/components/phone/materialPEResultComponent.vue";
    import myUtil from "@/util/util";
    import SearchMaterialResult from "@/components/shopopee/dataDisplay/searchMaterialResult.vue";
    import ListDisplayToggle from "@/components/shopopee/common/listDisplayToggle.vue";

    const emits = defineEmits(['go-shop', "changeView"])
    const props = defineProps(['materialObj', "keyword", "viewList", "viewName"])

    let { proxy } = getCurrentInstance();
    const i18n = inject("i18n")

    const keyword = ref("")
    const materialList = ref([])
    const orgMaterialList = ref([])
    const loadingFlag = ref(false)
    const viewType = ref("block")

    const cols = ref(12)

    const { goMaterialPosition } = inject('threePEFunc', { goMaterialPosition: () => {} })
    const { getMaterialListData } = inject('threePEFunc', { getMaterialList: () => {} })

    function changeKeyword() {
        if (null == keyword.value || "" === keyword.value){
            materialList.value = orgMaterialList.value
        }else{
            materialList.value = []

            for (const key in orgMaterialList.value){
                const obj = orgMaterialList.value[key]
                if (obj.productname.indexOf(keyword.value) != -1 || (null != obj.description && obj.description.indexOf(keyword.value) != -1)){
                    materialList.value.push(obj)
                }
            }

        }
    }

    function goShop(obj) {
        goMaterialPosition(obj.wa, obj.siojournal)
    }

    function changeViewType(name){
        viewType.value = name

        if (name === "block"){
            if (myUtil.isMobile()){
                cols.value = 12
            }else{
                cols.value = 6
            }
        }else{
            cols.value = 24
        }
    }


    onMounted(() => {

        if (null != props.keyword){
            keyword.value = props.keyword
        }

        changeKeyword()
    })

    onBeforeMount(() => {
        if (!myUtil.isMobile()){
            cols.value = 6
        }

        orgMaterialList.value = getMaterialListData()
    })

</script>

<style scoped>
    ul {
        list-style: none;
        margin: 0;
        padding-left: 0;
    }

    .search-box {
        text-align: center;
        width: 80%;
        margin: auto;
        box-sizing: border-box;
        padding: 10px;
        height: 60px;
    }

    .search-result {
        width: 100%;
        height: calc(100% - 60px);
        padding: 10px;
        overflow-x: hidden;
        overflow-y: auto;
        box-sizing: border-box;
    }

    .record-box {
        margin-bottom: 10px;
    }

    .type-toggle-box {
        text-align: right;
        box-sizing: border-box;
        padding: 0 20px;
    }

</style>